import React, {useEffect, useState} from "react";
import flag from "../../assets/imgs/gh.svg";
import {useForm} from "react-hook-form";

import merchant from "../../network/services/merchant";
import {getCourierBusinessId} from "../../helpers/authenticator";
import toastifyHelper from "../../helpers/toastify_helper";

const AddRider = () => {
    const {register, handleSubmit, watch, errors} = useForm();


    const handleRiderSignUp = (data) => {
        data.dob = "";
        data.image_url = "";
        data.merchant_id = getCourierBusinessId();
        data.bio = "";

        merchant.createDeliveryAgent(getCourierBusinessId(), data).then(response => {
            toastifyHelper.toastify.successToastify(response.data.message);
        }).catch(error => {
            toastifyHelper.toastify.errorToastify(error.response.data.error);

        })
    };

    return (
        <div className="mainWrapper" style={{marginTop: 150}}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-5">
                        <form onSubmit={handleSubmit(handleRiderSignUp)}>
                            <ul className="list-unstyled">
                                <li>
                                    <div style={{paddingLeft: 0, paddingRight: 0, paddingTop: 0, paddingBottom: 16}}>
                                        <ul className="list-unstyled">
                                            <li>
                                                <h6>Sign a rider on</h6>
                                            </li>
                                            <li style={{marginTop: 15}}>
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                    <span className="input-group-text" id="basic-addon1">
                                                        <img style={{height: 14, marginRight: 5}} src={flag}
                                                             className="img-fluid"/> +233
                                         </span>
                                                    </div>
                                                    <input type="text"
                                                           className="form-control form-control-lg input-form"
                                                           placeholder="Enter your phone number"
                                                           maxLength="10"
                                                           name="phone"
                                                           ref={register({required: true})}
                                                           aria-label="Username" aria-describedby="basic-addon1"/>
                                                </div>
                                            </li>
                                            <li>
                                                <hr/>
                                            </li>
                                            <li style={{marginTop: 15}}>
                                                <div className="input-group">
                                                    <input type="text"
                                                           className="form-control form-control-lg input-form-alt"
                                                           placeholder="Full name"
                                                           name="full_name"
                                                           ref={register({required: true})}
                                                           aria-label="Username" aria-describedby="basic-addon1"/>
                                                </div>
                                            </li>
                                            <li style={{marginTop: 15}}>
                                                <div className="input-group">
                                                    <input type="text"
                                                           className="form-control form-control-lg input-form-alt"
                                                           placeholder="Email"
                                                           name="email"
                                                           ref={register({required: true})}
                                                           aria-label="Username" aria-describedby="basic-addon1"/>
                                                </div>
                                            </li>

                                            <li style={{marginTop: 15}}>
                                                <div className="input-group">
                                                    <input type="text"
                                                           className="form-control form-control-lg input-form-alt"
                                                           placeholder="Address"
                                                           name="address"
                                                           ref={register({required: true})}
                                                           aria-label="Username" aria-describedby="basic-addon1"/>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li>
                                    <button className="btn btn-primary btn-md btn-block">
                                        Add Rider
                                    </button>
                                </li>
                            </ul>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddRider;
